import React, { Component } from "react";
import { CustomDatePicker } from "../DatePicker";
import { CustomTextField } from "./TextField";
import moment from "moment";
import { validators, validate } from "../../helpers/validationHelpers";
import { DATE_OF_BIRTH } from "../../consts/formKeys";
import { isMobileDevice } from "../../../../utils";

class DateOfBirth extends Component {
  static defaultProps = {
    value: null,
    errorText: undefined,
    onChange: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      isValid: false
    };
  }

  validate = value => {
    const { fieldKey, onError } = this.props;
    const errorMessage = validate(validators[fieldKey], value);
    if (errorMessage !== this.props.errorText) {
      onError(fieldKey, errorMessage);

      if (errorMessage === "") {
        if (!this.state.isValid)
          this.setState({
            isValid: true
          });
      } else {
        if (this.state.isValid)
          this.setState({
            isValid: false
          });
      }
    }
  };

  handleDismiss = () => {
    this.validate(this.props.value);
  };

  handleChange = value => {
    this.validate(value);
    this.props.onChange(DATE_OF_BIRTH, value);
  };

  handleChangeMobile = e => {
    const value = moment(e.target.value).format("DD/MM/YYYY");
    this.validate(value);
    this.props.onChange(DATE_OF_BIRTH, value);
  };

  render() {
    const isMobile = isMobileDevice();
    return isMobile ? (
      <CustomTextField
        floatingLabelText="Date of birth (dd/mm/yyyy) *"
        value={
          this.props.value
            ? moment(this.props.value, "DD/MM/YYYY").format("YYYY-MM-DD")
            : ""
        }
        placeholder=""
        errorText={this.props.errorText}
        onChange={this.handleChangeMobile}
        onBlur={this.handleBlur}
        isValid={
          this.state.isValid &&
          this.props.value !== moment().format("DD/MM/YYYY")
        }
        type="date"
        min="1900-01-01"
        max={moment().format("YYYY-MM-DD")}
      />
    ) : (
      <CustomDatePicker
        floatingLabelText="Date of birth (dd/mm/yyyy) *"
        errorText={this.props.errorText}
        value={this.props.value}
        onDateChange={this.handleChange}
        isValid={this.state.isValid}
      />
    );
  }
}

export { DateOfBirth };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/DateOfBirth.js